<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow pb-4"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto mt-25" :style="!isVerticalMenuCollapsed ||
                    (isVerticalMenuCollapsed && isMouseHovered) == true
                      ? 'margin-left: auto' : 'margin-left: 4px'">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <b-img
                  :src="appLogoImage"
                  :style="
                    !isVerticalMenuCollapsed ||
                    (isVerticalMenuCollapsed && isMouseHovered) == true
                      ? 'max-width: 100px'
                      : 'max-width: 45px'
                  "
                  alt="logo"
                />
              </span>
              <br />

              <!-- <h2 class="brand-text">
                {{ appName }}
              </h2> -->
            </b-link>
          </li>

          <!-- Toggler Button -->
        </ul>
      </slot>
    </div>
    <div class="nav-item nav-toggle">
      <b-link class="nav-link modern-nav-toggle ml-auto d-flex mr-2">
        <!-- <img
          src="@/assets/images/icons/new-icon/Arrow.png"
          class="d-xl-none"
          alt=""
        /> -->
        <!-- <feather-icon
          icon="XIcon"
          size="20"
          class="d-block d-xl-none"
          @click="toggleVerticalMenuActive"
        /> -->
        <img
          src="@/assets/images/icons/new-icon/Arrow.png"
          width="15px"
          height="20px"
          @click="toggleCollapsed"
          :class="[
            collapseTogglerIconFeather != 'DiscIcon' ? 'rotate-180' : '',
            'ml-auto',
          ]"
          alt=""
        />

        <!-- <feather-icon
          :icon="collapseTogglerIconFeather"
          size="20"
          class="d-none d-xl-block collapse-toggle-icon"
          @click="toggleCollapsed"
        /> -->
      </b-link>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems1"
        :class="['navigation navigation-main']"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
//import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import useJwt from "@/auth/jwt/useJwt";
import EventBus from "@/EvenBus";
var navMenuItems = [];
export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  computed: {
    navMenuItems1() {
      return this.$store.state.masterData.menu;
    },
  },
  watch: {
    isMouseHovered() {
      EventBus.$emit(
        "isExpanded",
        !this.isVerticalMenuCollapsed ||
          (this.isVerticalMenuCollapsed && this.isMouseHovered)
      );
    },
    isVerticalMenuCollapsed() {
      EventBus.$emit(
        "isExpanded",
        !this.isVerticalMenuCollapsed ||
          (this.isVerticalMenuCollapsed && this.isMouseHovered)
      );
    },
  },
  // created() {
  //   this.navMenuItems1 = this.$store.state.masterData.menu;
  // },

  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
